export class CiramailAssignToUserResultDto {
    userId: string;
    displayName: string;
    title: string;
    rank: string;
    // Transient field
    teamName: string;
    get searchText(): string {
        return `${this.teamName} ${this.displayName}`;
    }
}
